exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-form {\r\n  min-width: 150px;\r\n  width: 100%;\r\n}\r\n\r\n.example-full-width {\r\n  width: 50%;\r\n}\r\n\r\n.loginLogoMobile {\r\n  margin-right: 5%;\r\n  margin-left: 5%;\r\n}\r\n\r\n.forgot-my-password {\r\n  color: #2cbbc3;\r\n  cursor: pointer;\r\n}\r\n\r\n.forgot-my-password:hover {\r\n  -webkit-text-decoration-line: underline;\r\n          text-decoration-line: underline;\r\n}\r\n\r\n@media (max-device-width: 720px) {\r\n  .loginLogoMobile {\r\n    float: unset !important;\r\n\r\n  }\r\n  .loginTitleMobile {\r\n    width:90% !important;\r\n    margin: 5%;\r\n    margin-left:0 !important;\r\n    transform:translateY(0) !important;\r\n  }\r\n\r\n  .loginFormMobile {\r\n    float: unset !important;\r\n    width: 85%!important;\r\n    margin: 5px;\r\n\r\n  }\r\n\r\n  .loginFormFieldsMobile {\r\n    width: 30% !important;\r\n  }\r\n\r\n  .loginContainerMobile {\r\n    top: 10% !important;\r\n  }\r\n\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/login/login.component.css
// module id = ../../../../../src/app/components/login/login.component.css
// module chunks = main